import SolutionFeaturesI18n from "@/components/landing/shared/SolutionFeaturesI18n";
import { Target, MessageCircle, Link2, Calendar, Inbox, BarChart3 } from "lucide-react";
const VertriebFeaturesSection = () => <SolutionFeaturesI18n translationPrefix="vertriebSolution" icons={[Target, MessageCircle, Link2, Calendar, Inbox, BarChart3]} />;
export default VertriebFeaturesSection;
